import NotesStatus from "@/components/notes-status";
import styles from "@/components/notes-toolbar.module.css";
import { NoteSavingStatus } from "@/types";
import { faMarkdown } from "@fortawesome/free-brands-svg-icons";
import {
	faChevronLeft,
	faTableColumns,
	faThumbTack,
	faTrashCan,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { t } from "i18next";
import { JSX } from "react";

interface NotesToolbarProps {
	canDeleteNote: boolean;
	canPinNote: boolean;
	closeNote: () => void;
	deleteNote: () => Promise<void>;
	isMarkdownEnabled: boolean;
	isNoteOpened: boolean;
	isNotePinned: boolean;
	isSplitEditorEnabled: boolean;
	isStatusHighlighted: boolean;
	onMarkdownButtonClick: () => void;
	savingStatus: NoteSavingStatus;
	toggleNotePin: () => Promise<void>;
	toggleSplitEditor: () => void;
	wordCount: string;
}

function NotesToolbar({
	canDeleteNote,
	canPinNote,
	closeNote,
	deleteNote,
	isMarkdownEnabled,
	isNoteOpened,
	isNotePinned,
	isSplitEditorEnabled,
	isStatusHighlighted,
	onMarkdownButtonClick,
	savingStatus,
	toggleNotePin,
	toggleSplitEditor,
	wordCount,
}: NotesToolbarProps): JSX.Element {
	return (
		<div className={styles["toolbar"]}>
			<div className={styles["buttons-container"]}>
				<button
					className={styles["back-button"]}
					onClick={closeNote}
					title={t("back")}
					type="button"
				>
					<FontAwesomeIcon icon={faChevronLeft} />
				</button>
				<button
					aria-checked={isNotePinned}
					className={styles["pin-note-button"]}
					disabled={!canPinNote}
					onClick={() => void toggleNotePin()}
					role="checkbox"
					title={
						isNotePinned
							? t("pinnedToHomeScreen")
							: t("pinToHomeScreen")
					}
					type="button"
				>
					<FontAwesomeIcon icon={faThumbTack} />
				</button>
				<button
					aria-checked={isMarkdownEnabled}
					disabled={!isNoteOpened}
					onClick={onMarkdownButtonClick}
					role="checkbox"
					title={t("markdownMode")}
					type="button"
				>
					<FontAwesomeIcon icon={faMarkdown} />
				</button>
				<button
					aria-checked={isSplitEditorEnabled}
					className={styles["split-editor-button"]}
					hidden={!isMarkdownEnabled}
					onClick={toggleSplitEditor}
					role="checkbox"
					title={t("splitEditor")}
					type="button"
				>
					<FontAwesomeIcon icon={faTableColumns} />
				</button>
				<button
					aria-haspopup="dialog"
					className={styles["danger"]}
					disabled={!canDeleteNote}
					onClick={() => void deleteNote()}
					title={t("delete")}
					type="button"
				>
					<FontAwesomeIcon icon={faTrashCan} />
				</button>
			</div>
			{isNoteOpened && (
				<NotesStatus
					isStatusHighlighted={isStatusHighlighted}
					savingStatus={savingStatus}
					wordCount={wordCount}
				/>
			)}
		</div>
	);
}

export default NotesToolbar;
